import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class HttpService {

  constructor(private http: HttpClient) { }

  post(serviceName: string, data: any) {
    const callHeaders = new HttpHeaders({ 'Content-Type': 'application/json'});
    const options = { headers: callHeaders };
    const url = environment.apiUrl + serviceName;
    return this.http.post(url, JSON.stringify(data), options);
  }

  put(serviceName: string, data: any) {
    const callHeaders = new HttpHeaders({ 'Content-Type': 'application/json'});
    const options = { headers: callHeaders };
    const url = environment.apiUrl + serviceName;
    return this.http.put(url, JSON.stringify(data), options);
  }

  get(serviceName: string) {
    const url = environment.apiUrl + serviceName;
    return this.http.get(url);
  }

  delete(serviceName: string) {
    const url = environment.apiUrl + serviceName;
    return this.http.delete(url);
  }
}
